export default Object.freeze({
    COLLECTION_CURRENT_VERSION: 1,
    FEH_APP_LAUNCH_DATE: new Date(2017, 1, 2, 7, 0, 0),
    WEBSITE_NAME: "FEH Collector"
});